import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'header[app-main-header]',
  imports: [RouterModule],
  templateUrl: './main-header.html',
  styleUrl: './main-header.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class MainHeader {

  get appname(): string {
    return environment.appname;
  }

  get free_shipping_threshold(): number {
    return environment.free_shipping_threshold;
  }
}
